import React, {Component} from 'react';
import {connect} from 'react-redux';

import PackageAddDialog from 'components/packages/PackageAddDialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';


class ActionButton extends Component {

    render() {
        if (this.props.path === '/') {
            return (
                <PackageAddDialog
                    wrapper={FloatingActionButton}
                    wrapperProps={{style: {position: 'fixed', bottom: 20, right: 20}}}
                    icon={ContentAdd}
                    iconStyle={{fill: '#000'}}
                />
            )
        }
        return null;
    }

}

const mapStateToProps = (state) => {
    return {path: state.router.location.pathname}
};

export default connect(mapStateToProps)(ActionButton);




// WEBPACK FOOTER //
// ./src/components/ActionButton.js